import AtFlagImage from '../../../assets/austria-flag.png'
import ChFlagImage from '../../../assets/swiss-flag.png'
import DeFlagImage from '../../../assets/german-flag.png'

import ELocale from '../../../types/locales'

type DisplayProps = {
  imageSrc: string
  label: string
  description: string
  options: {
    link: string
    name: string
  }[]
}

const getContent = (locale: ELocale): DisplayProps => {
  const optionDE = { link: `www.hse.de`, name: 'Deutschland' }
  const optionAT = { link: `www.hse.at`, name: 'Österreich' }
  const optionCH = { link: 'www.hse24.ch', name: 'Schweiz' }

  switch (locale) {
    case ELocale.DE_AT:
      return {
        imageSrc: AtFlagImage,
        label: 'Austria flag icon',
        description: `Sie befinden sich auf der österreichischen Seite von HSE. Für Lieferungen nach Deutschland oder in die Schweiz wechseln Sie bitte die Landeseinstellung:`,
        options: [optionAT, optionDE, optionCH],
      }
    case ELocale.DE_CH:
      return {
        imageSrc: ChFlagImage,
        label: 'Switzerland flag icon',
        description: `Sie befinden sich auf der schweizerischen Seite von HSE. Für Lieferungen nach Deutschland oder nach Österreich wechseln Sie bitte die Landeseinstellung:`,
        options: [optionCH, optionDE, optionAT],
      }
    default:
      return {
        imageSrc: DeFlagImage,
        label: 'german flag icon',
        description: `Sie befinden sich auf der deutschen Seite von HSE. Für Lieferungen in Ihre Region wechseln Sie bitte die Landeseinstellung:`,
        options: [optionDE, optionAT, optionCH],
      }
  }
}

export default getContent
